import React from "react";
import { NavLink, Outlet } from "react-router-dom";
import { can } from "../lib/perms";
import { useAuth } from "../lib/auth";
import { Button } from "../components/ui/button";
import { Package, Calculator, LogOut, ReceiptText, ClipboardList, Users, Car, StickyNote } from "lucide-react";

export default function AppLayout() {
  const { user, logout } = useAuth();

  const navBase =
    "flex items-center gap-3 px-4 py-3 border border-transparent text-sm font-semibold uppercase tracking-wide transition-colors";
  const activeCls = "bg-black text-white border-black";
  const inactiveCls = "text-black hover:bg-zinc-100 border-zinc-200";

  return (
    <div className="min-h-screen grid grid-cols-1 md:grid-cols-[260px_1fr] bg-white">
      {/* Sidebar */}
      <aside className="border-r border-zinc-200 bg-white md:sticky md:top-0 md:h-screen flex flex-col" data-testid="sidebar">
        <div className="p-6 border-b border-zinc-200">
          <div className="flex items-center gap-3">
            <img
              src="/logo.png"
              alt="CostaNov logo"
              className="w-10 h-10 object-contain"
              data-testid="sidebar-logo"
            />
            <div>
              <div className="font-display text-xl font-bold tracking-tighter text-black">CostaNov</div>
              <div className="font-mono text-[10px] uppercase text-zinc-500">Panou intern</div>
            </div>
          </div>
        </div>
        <nav className="p-4 flex flex-col gap-2 flex-1">
          {can(user, "materials") && (
            <NavLink
              to="/materiale"
              className={({ isActive }) => `${navBase} ${isActive ? activeCls : inactiveCls}`}
              data-testid="nav-materials"
            >
              <Package size={18} />
              Materiale
            </NavLink>
          )}
          {can(user, "calculator") && (
            <NavLink
              to="/calculator"
              className={({ isActive }) => `${navBase} ${isActive ? activeCls : inactiveCls}`}
              data-testid="nav-calculator"
            >
              <Calculator size={18} />
              Calculator
            </NavLink>
          )}
          {can(user, "deviz") && (
            <NavLink
              to="/deviz"
              className={({ isActive }) => `${navBase} ${isActive ? activeCls : inactiveCls}`}
              data-testid="nav-deviz"
            >
              <ClipboardList size={18} />
              Deviz materiale
            </NavLink>
          )}
          {can(user, "invoices") && (
            <NavLink
              to="/facturi"
              className={({ isActive }) => `${navBase} ${isActive ? activeCls : inactiveCls}`}
              data-testid="nav-invoices"
            >
              <ReceiptText size={18} />
              Facturi
            </NavLink>
          )}
          {can(user, "vehicles") && (
            <NavLink
              to="/vehicule"
              className={({ isActive }) => `${navBase} ${isActive ? activeCls : inactiveCls}`}
              data-testid="nav-vehicles"
            >
              <Car size={18} />
              Vehicule
            </NavLink>
          )}
          {can(user, "notes") && (
            <NavLink
              to="/notite"
              className={({ isActive }) => `${navBase} ${isActive ? activeCls : inactiveCls}`}
              data-testid="nav-notes"
            >
              <StickyNote size={18} />
              Notite
            </NavLink>
          )}
          {user?.role === "admin" && (
            <NavLink
              to="/conturi"
              className={({ isActive }) => `${navBase} ${isActive ? activeCls : inactiveCls}`}
              data-testid="nav-accounts"
            >
              <Users size={18} />
              Conturi
            </NavLink>
          )}
        </nav>
        <div className="p-4 border-t border-zinc-200 space-y-2">
          <div className="text-xs text-zinc-500 font-mono">
            {user?.email}
          </div>
          <Button
            variant="outline"
            onClick={logout}
            className="w-full rounded-sm border-zinc-300 text-black hover:bg-zinc-100"
            data-testid="logout-button"
          >
            <LogOut size={16} className="mr-2" />
            Deconectare
          </Button>
        </div>
      </aside>

      <main className="min-w-0">
        <Outlet />
      </main>
    </div>
  );
}
